<template>
  <div class="extra-card">
    <div class="extra-card__content">
      <div
        :class="getTextColor()"
        class="extra-card__text font-m font-24 text-center"
      >
        <slot name="ctaText" />
      </div>
      <a :href="getOffersUrl()" class="btn btn-lg btn-yellow">
        <slot name="buttonText" />
      </a>
    </div>
    <div class="extra-card__image">
      <img :src="getImageUrl()" alt="Więcej ofert" />
    </div>
  </div>
</template>

<script>
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

export default {
  name: "extra-card",
  mixins: [domainTypeMixin],
  props: {
    imageName: String,
    offersUrl: String,
    textColor: String,
  },
  data: () => ({
    imagePath: "https://media.travelone.pl/travelonecdn/images/top-offers/",
  }),
  methods: {
    getOffersUrl() {
      return this.offersUrl;
    },
    getImageUrl() {
      let image = this.imageName + ".jpg";
      if (this.getDomainType("travelone", "")) {
        return this.imagePath + "travelone/" + image;
      } else if (this.getDomainType("", "skione")) {
        return this.imagePath + "skione/" + image;
      }
    },
    getTextColor() {
      if (this.textColor == "dark") {
        return "c-blue-dark font-b";
      } else if (this.textColor == "light") {
        return "c-white";
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.extra-card {
  border-radius: 3px;
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  backface-visibility: hidden;
  transform: translateZ(0);

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 24px;
    position: absolute;
    z-index: 1;
  }

  &__text {
    line-height: 1.275;
    margin-top: -4px;
  }

  &__image {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
    }
  }
}
</style>
